import React from 'react';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@iso/config/theme/theme.config';

export default function AppProvider({ children }) {
  const { themeName } = useSelector(state => state.ThemeSwitcher.changeThemes);
  return (
    <ConfigProvider>
      <IntlProvider>
        <ThemeProvider theme={themes[themeName]}>{children}</ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
}
